export function createId(prefix: string): string {
  const random = crypto.getRandomValues(new Uint32Array(4));
  const body = Array.from(random, (part) => part.toString(16).padStart(8, "0")).join("");
  return `${prefix}_${body}`;
}

export function nowIso(): string {
  return new Date().toISOString();
}

